
import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'aos/dist/aos.css'
import axios from 'axios'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(VueMeta)

axios.defaults.baseURL = 'https://cdn.ito-consult.de/itoconsult/items'
new Vue({
  router,
  store,
  render: h => h(App),
  async mounted () {
    const AOS = await import('aos')
    AOS.init({
      once: true
    })
  }
}).$mount('#app')
